module.exports = __webpack_public_path__ + "img/gaizaofangxiang.5b9eaee0.png";